import React from 'react';
import EntryPopover from '../EntryPopover/EntryPopover';
import styles from './NewEntrySection.module.scss';

interface NewEntrySectionProps {
  userRole?: string;
  isPopoverOpen: boolean;
  onPopoverOpenChange: (open: boolean) => void;
  onCreateFolder: () => void;
  onCreateFile: () => void;
}

const NewEntrySection: React.FC<NewEntrySectionProps> = ({
  userRole,
  isPopoverOpen,
  onPopoverOpenChange,
  onCreateFolder,
  onCreateFile
}) => {
  return (
    <div className={styles.newEntryContainer}>
      <div className={styles.newEntryHeader}>
        <div className={styles.headerContent}>
          {/* New Entry — EntryPopover: Admin, SuperAdmin, Editor */}
          <EntryPopover
            isOpen={isPopoverOpen}
            onOpenChange={onPopoverOpenChange}
            onCreateFolder={onCreateFolder}
            onCreateFile={onCreateFile}
            userRole={userRole}
          />
        </div>
      </div>
    </div>
  );
};

export default NewEntrySection; 